import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './ACWTimer.module.css';

interface AcwTimerActionsProps {
  canGoAvailable: boolean;
  isSaving: boolean;
  isExtending: boolean;
  requireDisposition: boolean;
  selectedDispositionId: string;
  isWarning: boolean;
  onGoAvailable: () => void;
  onExtend?: (seconds: number) => void;
}

export function AcwTimerActions({
  canGoAvailable,
  isSaving,
  isExtending,
  requireDisposition,
  selectedDispositionId,
  isWarning,
  onGoAvailable,
  onExtend,
}: AcwTimerActionsProps) {
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.actions}>
        <button
          className={styles.availableButton}
          onClick={onGoAvailable}
          disabled={!canGoAvailable || isSaving}
          title={!canGoAvailable ? t('acw:timer.selectDispositionFirst') : undefined}
        >
          {isSaving ? t('common:status.saving') : t('acw:timer.goAvailable')}
        </button>

        {onExtend && (
          <button
            className={styles.extendButton}
            onClick={() => onExtend(60)}
            disabled={isExtending}
          >
            {t('acw:timer.extendMinute')}
          </button>
        )}
      </div>

      {requireDisposition && !selectedDispositionId && (
        <p className={styles.warningText}>{t('acw:timer.dispositionRequired')}</p>
      )}

      {isWarning && <p className={styles.warningText}>{t('acw:timer.timeEndingSoon')}</p>}
    </>
  );
}
